import React, { Component } from 'react';
import WithConsumer from '../context/WithConsumer';

const CartModalQty = ({ index, context }) => {
    
	const ctxCartOpen = () => context.cartOpen;
	const cartOpen = ctxCartOpen();
	
	const ctxUser = () => context.user;
	const user = ctxUser();
			
	if (user.id !== false && user.id !== 'false' && user.id !== null) {
		
		let qty;

		function changeInput(event) {
			qty = event.target.value;
		}
		
		function changeQtyCart(event) {
			context.editCart(index, parseInt(event.target.value), false);
		}
		
		setTimeout(function(){
			if (document.getElementsByClassName('c-cart__item__cell__qty--' + index).length > 0) {
				document.getElementsByClassName('c-cart__item__cell__qty--' + index)[0].value = user.cart.items[index].qty;
			}
		}, 100);
			
		return (
			<input className={'c-cart__item__cell__qty c-cart__item__cell__qty--' + index} type="number" value={qty} data-index={index} onChange={event => (qty = event.target.value)} onBlur={event => (context.editCart(user.cart.items[index], parseInt(event.target.value), false))} />
		)
				
	} else {
		return null;
	}

}
export default WithConsumer(CartModalQty);